import imgHankyu51 from "./tipe 5 (1).png";
import imgHankyu52 from "./tipe 5 (2).png";
import imgHankyu53 from "./tipe 5 (3).png";

const imghankyu5 = [imgHankyu51, imgHankyu52, imgHankyu53];
export default imghankyu5;
